<script setup lang="ts">
// PROPS
interface Props {
    highlighted?: boolean;
}

const props = defineProps<Props>();

// DATA
const ui = computed(() => ({
    root: props.highlighted ? 'ring-primary-200' : undefined,
    header: 'p-0 sm:px-0 bg-contain aspect-4/3 max-w-full relative overflow-hidden',
    body: props.highlighted ? 'p-3 sm:p-3 bg-primary-50' : 'p-3 sm:p-3',
}));
</script>

<template>
    <UCard :ui="ui" variant="outline">
        <template #header>
            <slot name="header" />
        </template>
        <div class="text-dimmed overflow-hidden text-xs leading-4 font-medium tracking-normal text-ellipsis whitespace-nowrap">
            <slot name="class">&nbsp;</slot>
        </div>
        <div class="overflow-hidden text-base leading-6 font-medium tracking-normal text-ellipsis whitespace-nowrap">
            <slot name="model" />
        </div>
        <div class="flex flex-row justify-between">
            <span class="flex flex-row items-center text-xs leading-4 font-medium tracking-normal lg:max-w-20">
                <UIcon class="size-5" name="lucide:calendar" />
                <span class="ml-1 block overflow-hidden text-nowrap text-ellipsis"><slot name="registration" /></span>
            </span>
            <span class="flex flex-row items-center text-xs leading-4 font-medium tracking-normal lg:max-w-20">
                <UIcon class="size-5" name="lucide:circle-gauge" />
                <span class="ml-1 block overflow-hidden text-nowrap text-ellipsis"><slot name="kilometer" /></span>
            </span>
            <span class="flex flex-row items-center text-xs leading-4 font-medium tracking-normal lg:max-w-20">
                <UIcon class="size-5" name="lucide:bus-front" />
                <span class="ml-1 block overflow-hidden text-nowrap text-ellipsis"><slot name="euro-norm" /></span>
            </span>
        </div>

        <div v-if="$slots.price" class="flex items-center gap-3 text-3xl leading-9 font-medium tracking-normal"><slot name="price" /></div>

        <div v-if="$slots.status" class="min-h-6"><slot name="status" /></div>
    </UCard>
</template>
